import { GETPROFILEPIC, GETPROFILEPIC_ERROR, GETPROFILEPIC_HIDE_ERROR, GETPROFILEPIC_START_LOADER, GETPROFILEPIC_STOP_LOADER } from "../interface/IGetProfilePic";
const initState = {
    data: {},
    loader: false,
    errorData: {
        error: null,
        isOpen: false,
    },
};
const GetProfilePicReducer = (state = initState, action) => {
    switch (action.type) {
        case GETPROFILEPIC:
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        case GETPROFILEPIC_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case GETPROFILEPIC_HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: initState.errorData });
        case GETPROFILEPIC_START_LOADER:
            return Object.assign(Object.assign({}, state), { loader: true });
        case GETPROFILEPIC_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { loader: false });
        default:
            return Object.assign({}, state);
    }
};
export default GetProfilePicReducer;
